import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

import { measurePanelAnchor, PanelAnchor } from '../../shared/panel-position.util';

@Component({
  selector: 'app-search-select',
  templateUrl: './search-select.component.html',
  styleUrls: ['./search-select.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchSelectComponent implements OnChanges, OnDestroy {
  @Input() label: string;
  @Input() placeholder = 'Select…';
  @Input() searchPlaceholder = 'Search…';
  @Input() required = false;
  @Input() disabled = false;
  @Input() options: string[] = [];
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  @ViewChild('trigger', { static: false }) triggerRef: ElementRef<HTMLDivElement>;

  open = false;
  query = '';
  filtered: string[] = [];
  anchor: PanelAnchor | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options) {
      this._applyFilter();
    }
  }

  ngOnDestroy(): void {
    this.open = false;
  }

  get panelStyle(): { [k: string]: string } {
    const a = this.anchor;
    return {
      position: 'fixed',
      left: a ? `${a.left}px` : '0px',
      top: a ? `${a.top}px` : '100%',
      width: a ? `${a.width}px` : '100%',
      'max-height': a ? `${a.maxH}px` : '270px',
      'z-index': '1051'
    };
  }

  toggle(): void {
    if (this.disabled) {
 return;
}
    if (this.open) {
      this.open = false;
      this.query = '';
      return;
    }
    this.query = '';
    this._applyFilter();
    this.anchor = this._measure();
    this.open = true;
  }

  close(): void {
    this.open = false;
    this.query = '';
  }

  pick(option: string): void {
    this.valueChange.emit(option);
    this.close();
  }

  clear(event: MouseEvent): void {
    event.stopPropagation();
    this.valueChange.emit('');
  }

  onQueryChange(q: string): void {
    this.query = q;
    this._applyFilter();
  }

  private _measure(): PanelAnchor | null {
    const el = this.triggerRef && this.triggerRef.nativeElement;
    return measurePanelAnchor(el, 270);
  }

  private _applyFilter(): void {
    const q = this.query.trim().toLowerCase();
    this.filtered = q
      ? (this.options || []).filter(o => o.toLowerCase().includes(q))
      : [...(this.options || [])];
  }
}
